module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/icons/unsure-e9fa6df616bfdfdeb9510bc7f5d85594.svg";